import { parseTimeInPint } from "@shared/common/utils/luxonHelpers";
import { Required } from "@tractie/components";
import { DateTime } from "luxon";

export class PintValidator extends Required {
  static get validatorName() {
    return "PintValidator";
  }

  execute(modelValue: string, _param: string) {
    return parseTimeInPint(modelValue, DateTime.local()) === undefined;
  }

  static getMessage() {
    return Promise.resolve("Vertrektijd is niet goed ingevoerd (00:00.0)");
  }
}
